export const FETCH_GET_TEMPLATE_TASK_BY_ID_REQUEST = 'FETCH_GET_TEMPLATE_TASK_BY_ID_REQUEST'
export const FETCH_GET_TEMPLATE_TASK_BY_ID_SUCCESS = 'FETCH_GET_TEMPLATE_TASK_BY_ID_SUCCESS'
export const FETCH_GET_TEMPLATE_TASK_BY_ID_FALUIRE = 'FETCH_GET_TEMPLATE_TASK_BY_ID_FALUIRE'
export const UPDATE_THERMIT_TEMPRATURE_VALUE_CURRENT = "UPDATE_THERMIT_TEMPRATURE_VALUE_CURRENT"
